import React, { useState, useEffect, useContext } from 'react';
import { ConfigContext } from '../context/ConfigContext';
import { motion } from 'framer-motion';
import { 
  Settings as SettingsIcon, 
  Palette, 
  Mail, 
  Bell, 
  Save,
  Globe
} from 'lucide-react';

const Settings = () => {
  const [generalSettings, setGeneralSettings] = useState({
    organizationName: 'BeneficiaHub',
    contactEmail: 'info@beneficiahub.org',
  defaultCurrency: '$',
    language: 'es'
  });

  const [notificationSettings, setNotificationSettings] = useState({
    enableEmailReminders: true,
    sendBirthdayReminders: true,
    sendPaymentDueReminders: true,
    reminderFrequencyDays: 7
  });

  // Cargar configuración desde el backend
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const { fetchConfig } = useContext(ConfigContext);
  const localFetchConfig = async () => {
  const res = await fetch('https://chungwhav2.tnf.cl/api/configuracion');
    const data = await res.json();
    const general = { ...generalSettings };
    const notification = { ...notificationSettings };
    let logoUrl = '';
    data.forEach(item => {
      if (general.hasOwnProperty(item.clave)) general[item.clave] = item.valor;
      if (notification.hasOwnProperty(item.clave)) {
        notification[item.clave] = item.valor === 'true' ? true : (item.clave === 'reminderFrequencyDays' ? Number(item.valor) : false);
      }
      if (item.clave === 'loginLogo') logoUrl = item.valor;
    });
    setGeneralSettings(general);
    setNotificationSettings(notification);
    setLogoPreview(logoUrl);
  };

  useEffect(() => {
    localFetchConfig();
  }, []);
  // Manejar cambio de archivo de logo
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setLogoFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
// ...existing code...
  
  const handleGeneralChange = (e) => {
    const { name, value } = e.target;
    setGeneralSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleNotificationChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNotificationSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

   // ...existing code...
  const handleSaveSettings = async () => {
    // Guardar configuración general
    for (const clave in generalSettings) {
  await fetch('https://chungwhav2.tnf.cl/api/configuracion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clave, valor: generalSettings[clave] })
      });
    }
    // Guardar configuración de notificaciones
    for (const clave in notificationSettings) {
  await fetch('https://chungwhav2.tnf.cl/api/configuracion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clave, valor: notificationSettings[clave] })
      });
    }
    // Subir logo si hay archivo nuevo
    if (logoFile) {
      const formData = new FormData();
      formData.append('logo', logoFile);
  const res = await fetch('https://chungwhav2.tnf.cl/api/configuracion/logo', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.url) {
  await fetch('https://chungwhav2.tnf.cl/api/configuracion', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ clave: 'loginLogo', valor: data.url })
        });
      }
    }
  await fetchConfig();
  await localFetchConfig();
    alert('¡Configuración guardada con éxito!');
  };
// ...existing code...

  return (
    <div className="space-y-8">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
      >
        <div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent mb-2">
            Configuración del Sistema
          </h1>
          <p className="text-gray-600">Personalice el funcionamiento de su plataforma Beneficencia</p>
        </div>
        
        <motion.button
          onClick={handleSaveSettings}
          className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Save className="w-5 h-5" />
          Guardar Configuración
        </motion.button>
      </motion.div>

      {/* General Settings */}
      <motion.div
        className="bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-2xl p-6 shadow-xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <div className="flex items-center gap-3 mb-6">
          <SettingsIcon className="w-6 h-6 text-blue-500" />
          <h2 className="text-xl font-bold text-gray-900">Configuración General</h2>
        </div>
        
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="flex flex-col items-start justify-center">
            <label className="block text-sm font-medium text-gray-700 mb-2">Logo actual</label>
            {logoPreview ? (
              <img src={logoPreview} alt="Logo" className="w-16 h-16 sm:w-24 sm:h-24 object-contain rounded-xl border mb-2" />
            ) : (
              <div className="w-16 h-16 sm:w-24 sm:h-24 bg-gray-100 flex items-center justify-center rounded-xl border mb-2 text-gray-400 text-xs sm:text-base">Sin logo</div>
            )}
            <input type="file" accept="image/*" onChange={handleLogoChange} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Nombre de la Organización</label>
            <input
              type="text"
              name="organizationName"
              value={generalSettings.organizationName}
              onChange={handleGeneralChange}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all duration-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Correo Electrónico de Contacto</label>
            <input
              type="email"
              name="contactEmail"
              value={generalSettings.contactEmail}
              onChange={handleGeneralChange}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all duration-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Moneda Predeterminada</label>
            <input
              type="text"
              name="defaultCurrency"
              value={generalSettings.defaultCurrency}
              onChange={handleGeneralChange}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all duration-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Idioma de la Interfaz</label>
            <select
              name="language"
              value={generalSettings.language}
              onChange={handleGeneralChange}
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all duration-300"
            >
              <option value="es">Español</option>
              <option value="en">English</option>
              <option value="zh">中文</option>
            </select>
          </div>
        </div>
      </motion.div>

      {/* Notification Settings */}
      <motion.div
        className="bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-2xl p-6 shadow-xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <div className="flex items-center gap-3 mb-6">
          <Bell className="w-6 h-6 text-purple-500" />
          <h2 className="text-xl font-bold text-gray-900">Configuración de Notificaciones</h2>
        </div>
        
        <div className="space-y-4">
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              name="enableEmailReminders"
              checked={notificationSettings.enableEmailReminders}
              onChange={handleNotificationChange}
              className="form-checkbox h-5 w-5 text-blue-600 rounded-md"
            />
            <span className="text-gray-700 font-medium">Habilitar recordatorios por correo electrónico</span>
          </label>

          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              name="sendBirthdayReminders"
              checked={notificationSettings.sendBirthdayReminders}
              onChange={handleNotificationChange}
              className="form-checkbox h-5 w-5 text-blue-600 rounded-md"
            />
            <span className="text-gray-700 font-medium">Enviar recordatorios de cumpleaños</span>
          </label>

          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              name="sendPaymentDueReminders"
              checked={notificationSettings.sendPaymentDueReminders}
              onChange={handleNotificationChange}
              className="form-checkbox h-5 w-5 text-blue-600 rounded-md"
            />
            <span className="text-gray-700 font-medium">Enviar recordatorios de vencimiento de pago</span>
          </label>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Frecuencia de Recordatorios (días antes)</label>
            <input
              type="number"
              name="reminderFrequencyDays"
              value={notificationSettings.reminderFrequencyDays}
              onChange={handleNotificationChange}
              min="1"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all duration-300"
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Settings;